import { isNull } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

class Tab extends React.Component {
  render() {
    const { title, classNames, eventKey, customRenderer } = this.props;

    const customLink = customRenderer(eventKey);
    if (!isNull(customLink)) {
      return customLink;
    }

    return (
      <a ref="link" className={classNames} data-eventkey={eventKey}>
        {title}
      </a>
    );
  }
}

Tab.propTypes = {
  eventKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  classNames: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  customRenderer: PropTypes.func,
};

Tab.defaultProps = {
  eventKey: '',
  classNames: ' ',
  title: '',
  customRenderer: () => null,
};

export default Tab;
